/**
 * This doesn't have to be its own module but Vite's HMR will complain and
 * clutter output. I hate this but don't want to tweak defaults. Let's leave
 * this alone.
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { NuqsAdapter } from "nuqs/adapters/react-router/v6";

import { Login, Shell } from "@granular/fabric3-core";
import Container from "./Container";

globalThis.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  console.info(
    "Error handled: vite:preloadError (unable to load JS chunk, probably because of a deployment). Reloading this window to get latest deployed app.",
  );
  globalThis.location.reload();
});

const rootElement = document.querySelector("#root");

/**
 * TODO: Why the check for the root element? What are we doing if it's absent?
 *       Are we just doing this to make Biome happy?
 */
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <NuqsAdapter>
        <BrowserRouter>
          {/*
          Note the order. We want to make sure that everything gets rendered
          inside the Shell, inside the Container's base layout[1], and with full
          access to the routing context (e.g. via `useLocation`)

          [1]: TODO: React Router provides a very elegant way of doing/ensuring
                     a base layout/common elements for a route. Do this later.
        */}
          <Routes>
            {/*
                We register the login route outside of the container. We don't
                want an unauthenticated user to see the sidebar, so this page
                should take up the whole viewport. 🖼️
              */}
            <Route path="/login/*" element={<Login />} />
            <Route
              path="/*"
              element={
                <Shell>
                  <Container />
                </Shell>
              }
            />
          </Routes>
        </BrowserRouter>
      </NuqsAdapter>
    </React.StrictMode>,
  );
}
